import { Button, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import RoundedTable from "@entrilia/shared/components/RoundedTable";
import type { Approval } from "../../api/types/approvalTypes";
import UserWithTimestamp from "../common/UserWithTimestamp";
import type { RequestOrigin } from "./ApprovalWidget";
import ApprovalStatusTag from "./ApprovalStatusTag";
import { getApprovalProgress } from "./approvalsHelper";

interface Props {
  approval: Approval;
  requestOrigin?: RequestOrigin;
  onShowDetails: () => void;
}

const ApprovalInfoTable = ({ approval, requestOrigin, onShowDetails }: Props) => {
  const requestedByUserName = requestOrigin?.requestedByUserName ?? approval.createdByUserName;
  const requestedAt = requestOrigin?.requestedAt ?? approval.createdAt;
  const showLastModified = !!requestOrigin;

  return (
    <RoundedTable withoutColumnBorders>
      <TableHead>
        <TableRow>
          <TableCell>Requested</TableCell>
          {showLastModified && <TableCell>Last Modified</TableCell>}
          <TableCell>Status</TableCell>
          <TableCell>Steps</TableCell>
          <TableCell width="6rem"></TableCell>
        </TableRow>
      </TableHead>

      <TableBody>
        <TableRow>
          <TableCell>
            <UserWithTimestamp userName={requestedByUserName} timestamp={requestedAt} />
          </TableCell>
          {showLastModified && (
            <TableCell>
              <UserWithTimestamp userName={approval.createdByUserName} timestamp={approval.createdAt} />
            </TableCell>
          )}
          <TableCell>
            <ApprovalStatusTag status={approval.status} />
          </TableCell>
          <TableCell>{getApprovalProgress(approval)}</TableCell>
          <TableCell>
            <Button variant="outlined" color="secondary" onClick={onShowDetails}>
              Details
            </Button>
          </TableCell>
        </TableRow>
      </TableBody>
    </RoundedTable>
  );
};

export default ApprovalInfoTable;
